import type { BatchLead, BatchLeadsFetcher } from './types';

/** The leads list's page size, as the grid itself pages it. */
const PAGE_SIZE = 50;

/**
 * Every ACTIVE lead at an event, all pages, in the order the list returns
 * them. The unified CRM grid's one load of them (`useGridLeadRows`): the
 * counts (port plan D9: Clean's rule-held term reads the lead rows), which
 * must be known before any CRM tab is opened, and every lens's rows.
 * `deleted: false` on every page: a deleted lead is never CRM work. Stops on
 * a server that hands back the cursor it was given, and — with `signal` — as
 * soon as the load is called off (a newer re-read superseded it): no page
 * after that is asked for.
 */
export async function loadAllActiveLeads(
  fetchLeads: BatchLeadsFetcher,
  conferenceId: string,
  signal?: AbortSignal,
): Promise<BatchLead[]> {
  const rows: BatchLead[] = [];
  let cursor: string | undefined;
  for (;;) {
    if (signal?.aborted) throw signal.reason ?? new DOMException('The load was called off', 'AbortError');
    const page = await fetchLeads({
      conferenceId,
      limit: PAGE_SIZE,
      deleted: false,
      ...(cursor ? { cursor } : {}),
    });
    rows.push(...page.leads);
    if (!page.nextCursor || page.nextCursor === cursor) return rows;
    cursor = page.nextCursor;
  }
}
